<template>
  <div class="navigation">
    <history />
    <search v-if="!$route.meta.hideSearch" />
  </div>
</template>

<script>
import History from "./History";
import Search from "./Search";
export default {
  name: "navigation",

  components: {
    Search,
    History
  }
};
</script>

<style lang="sass" scoped>

.navigation
  display: flex
  flex-flow: row
  z-index: 10
  width: 100%
  padding: 10px 0 10px 10px
  background: $bg-color
  box-shadow: 0px 2px 3px rgba(0, 0, 0, .1)

</style>